export const clientId = "smx-product-compliance";
export const roles = {
  admin: "admin",
  manager: "manager",
  viewer: "viewer",
} as const;

export type CountryOption = {
  code: string;
  name: string;
};

export type ComplianceActionOption = {
  value: string;
  labelKey: string;
};

export type ComplianceDepartmentOption = {
  value: string;
  labelKey: string;
  actions: ComplianceActionOption[];
};

export const COUNTRY_LIST: CountryOption[] = [
  { code: "AR", name: "Argentina" },
  { code: "AU", name: "Australia" },
  { code: "AT", name: "Austria" },
  { code: "BE", name: "Belgium" },
  { code: "BR", name: "Brazil" },
  { code: "BG", name: "Bulgaria" },
  { code: "CA", name: "Canada" },
  { code: "CL", name: "Chile" },
  { code: "CN", name: "China" },
  { code: "CO", name: "Colombia" },
  { code: "HR", name: "Croatia" },
  { code: "CZ", name: "Czechia" },
  { code: "DK", name: "Denmark" },
  { code: "EG", name: "Egypt" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "France" },
  { code: "DE", name: "Germany" },
  { code: "GR", name: "Greece" },
  { code: "HU", name: "Hungary" },
  { code: "IN", name: "India" },
  { code: "ID", name: "Indonesia" },
  { code: "IE", name: "Ireland" },
  { code: "IL", name: "Israel" },
  { code: "IT", name: "Italy" },
  { code: "JP", name: "Japan" },
  { code: "LV", name: "Latvia" },
  { code: "LT", name: "Lithuania" },
  { code: "LU", name: "Luxembourg" },
  { code: "MY", name: "Malaysia" },
  { code: "MX", name: "Mexico" },
  { code: "NL", name: "Netherlands" },
  { code: "NZ", name: "New Zealand" },
  { code: "NO", name: "Norway" },
  { code: "PE", name: "Peru" },
  { code: "PH", name: "Philippines" },
  { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" },
  { code: "RO", name: "Romania" },
  { code: "SA", name: "Saudi Arabia" },
  { code: "SG", name: "Singapore" },
  { code: "SK", name: "Slovakia" },
  { code: "SI", name: "Slovenia" },
  { code: "ZA", name: "South Africa" },
  { code: "KR", name: "South Korea" },
  { code: "ES", name: "Spain" },
  { code: "SE", name: "Sweden" },
  { code: "CH", name: "Switzerland" },
  { code: "TH", name: "Thailand" },
  { code: "TR", name: "Turkiye" },
  { code: "UA", name: "Ukraine" },
  { code: "AE", name: "United Arab Emirates" },
  { code: "GB", name: "United Kingdom" },
  { code: "US", name: "United States" },
  { code: "VN", name: "Vietnam" },
];

export const COMPLIANCE_DEPARTMENTS: ComplianceDepartmentOption[] = [
  {
    value: "plant_safety",
    labelKey: "sdsDeptPlantSafety",
    actions: [
      { value: "update_sops", labelKey: "sdsActionUpdateSops" },
      {
        value: "update_emergency_procedures",
        labelKey: "sdsActionUpdateEmergencyProcedures",
      },
      {
        value: "update_workplace_signage",
        labelKey: "sdsActionUpdateWorkplaceSignage",
      },
    ],
  },
  {
    value: "ehs",
    labelKey: "sdsDeptEhs",
    actions: [
      { value: "schedule_training", labelKey: "sdsActionScheduleTraining" },
      {
        value: "update_risk_assessment",
        labelKey: "sdsActionUpdateRiskAssessment",
      },
      { value: "report_to_authority", labelKey: "sdsActionReportToAuthority" },
    ],
  },
  {
    value: "procurement",
    labelKey: "sdsDeptProcurement",
    actions: [
      { value: "vendor_query", labelKey: "sdsActionVendorQuery" },
      {
        value: "supplier_qualification",
        labelKey: "sdsActionSupplierQualification",
      },
      { value: "source_alternative", labelKey: "sdsActionSourceAlternative" },
    ],
  },
  {
    value: "quality",
    labelKey: "sdsDeptQuality",
    actions: [
      {
        value: "update_specification",
        labelKey: "sdsActionUpdateSpecification",
      },
      {
        value: "update_product_data_sheet",
        labelKey: "sdsActionUpdateProductDataSheet",
      },
    ],
  },
  {
    value: "logistics",
    labelKey: "sdsDeptLogistics",
    actions: [
      {
        value: "update_transport_doc",
        labelKey: "sdsActionUpdateTransportDoc",
      },
      {
        value: "update_hazmat_declaration",
        labelKey: "sdsActionUpdateHazmatDeclaration",
      },
    ],
  },
  {
    value: "warehouse",
    labelKey: "sdsDeptWarehouse",
    actions: [
      {
        value: "update_storage_sop",
        labelKey: "sdsActionUpdateStorageSop",
      },
      {
        value: "review_segregation",
        labelKey: "sdsActionReviewSegregation",
      },
    ],
  },
];
